// extracted by mini-css-extract-plugin
export default {"header":"header__DTK6R","current":"current__iNGSs","navigation":"navigation__GTrWA","full":"full__+tWJr","initial":"initial__BysWz","short":"short__gVLdT"};